module.exports = __webpack_public_path__ + "static/vou-pra-nuvem-def3016aded0fe181ca0b5fa2a98f661.png";